import * as actionTypes from '../actions/actionTypes';
import moment from 'moment';

const initialState = {
    filter: {
        from: moment().subtract(6, "days").startOf("day").format("YYYY-MM-DD HH:mm:ss"),
        to: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
        gameType:"cash",
        level:"All Level",
        ringType: 'All',
        holeCards:[],
        sort: "desc",
        position: "All",
        handType: "All",
    },
    prevFilter: {
        from: moment().subtract(6, "days").startOf("day").format("YYYY-MM-DD HH:mm:ss"),
        to: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
        gameType:"cash",
        level:"All Level",
        ringType: 'All',
        holeCards:[],
        sort: "desc",
        position: "All",
        handType: "All",
    },
    selectedHandList: [],
};

const setHandHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_HAND_HISTORY_FILTER: return {...state, filter: action.data}
        case actionTypes.SET_SELECTED_HAND_LIST: return {...state, selectedHandList: action.data}
        case actionTypes.SET_HAND_HISTORY_PREV_FILTER: return {...state, prevFilter: action.data}
         default:
            return state;
    }
};

export default setHandHistoryReducer;


/** WEBPACK FOOTER **
 ** ./src/store/reducer/handHistoryReducer.js
 **/